/**
 * クッキーのキーを表します。
 */
export class N202SessionStorageKey {
  // 表示区分
  public static readonly N2021InitialKbn: string = 'N2021InitialKbn';
  // 発注情報
  public static readonly N2021HatchuInfo: string = 'N2021HatchuInfo';
  // 用途
  public static readonly N2022Yoto: string = 'N2022Yoto';
  // 納期変更メッセージ
  public static readonly N2022Nokihenkomesseji: string = 'N2022Nokihenkomesseji';
  // メッセージ表示域
  public static readonly N2022Nokihenkoriyu: string = 'N2022Nokihenkoriyu';
  // 希望車種名
  public static readonly N2025KIBOSHASHUMEI: string = 'N2025KIBOSHASHUMEI';
  // 配送ルート
  public static readonly N2025HAISORUTO: string = 'N2025HAISORUTO';
  // 荷量管理車種
  public static readonly N2025NIRYOKANRISHASHU: string = 'N2025NIRYOKANRISHASHU';
  // 遷移フラグ
  public static readonly N202SeniFlg: string = 'N202SeniFlg';
  // 商品区分
  public static readonly N202ShohinKubun: string = 'N202ShohinKubun';
  // 発注予定リスト
  public static readonly N202HatchuYoteiList: string = 'N202HatchuYoteiList';
  // 関連部材
  public static readonly N202HatchuData: string = 'N202HatchuData';
  // 受注No.
  public static readonly N202JUCHUNO: string = 'N202JUCHUNO';
  // 注文を取り消して再発注情報
  public static readonly N202ChumonHatchu: string = 'N202ChumonHatchu';
  // 左メニュー表示有無
  public static readonly N202TojiruFlg: string = 'N202TojiruFlg';
}



// WEBPACK FOOTER //
// ./src/app/modules/n202/n202-session-storage-key.ts